let restorePendingCard = null;

// Links stay native: the browser can start fetching the destination immediately.
export function navigateToExtension(event) {
  const link = event.currentTarget;
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    link.hasAttribute('download') ||
    (link.target && link.target !== '_self')
  )
    return true;

  const destination = new URL(link.href);
  if (destination.origin !== location.origin || destination.pathname !== '/extension') return true;
  if (location.pathname === destination.pathname) {
    event.preventDefault();
    return false;
  }

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('onpageswap' in window) ||
    !('onpagereveal' in window)
  )
    return true;

  restorePendingCard?.();
  link.dataset.extensionOpening = '';

  let recoveryTimer;
  const restore = () => {
    clearTimeout(recoveryTimer);
    delete link.dataset.extensionOpening;
    window.removeEventListener('pageswap', afterSwap);
    window.removeEventListener('pageshow', restore);
    restorePendingCard = null;
  };
  const afterSwap = ({ viewTransition }) => {
    if (viewTransition) viewTransition.finished.then(restore, restore);
    else restore();
  };
  restorePendingCard = restore;
  window.addEventListener('pageswap', afterSwap);
  window.addEventListener('pageshow', restore);
  // A cancelled or failed navigation must not leave a selected card behind.
  recoveryTimer = window.setTimeout(restore, 10000);
  return true;
}
